import {SUBSCRIPTION_STATUSES, SubscriptionStatusesType} from './constants';

type CheckboxDataType = {
    isVisible: boolean;
    isChecked: boolean;
};

type SubmitType = SubscriptionStatusesType | undefined;

/**
 * return type of subscription method
 * @param {CheckboxDataType} resultData - information about state checkbox
 * @returns {SubmitType} SubmitType
 */
export const checkUnknown = (resultData: CheckboxDataType): SubmitType => {
    let result: SubmitType;
    if (!resultData.isVisible || resultData.isChecked) {
        result = 'SUBSCRIBED';
    } else {
        result = 'TRANSITIONAL';
    }
    return result;
};

/**
 * return type of subscription method
 * @param {CheckboxDataType} resultData - information about state checkbox
 * @returns {SubmitType} SubmitType
 */
export const checkSubscribe = (resultData: CheckboxDataType): SubmitType => {
    let result: SubmitType;
    if (resultData.isVisible && !resultData.isChecked) {
        result = 'UNSUBSCRIBED';
    }
    return result;
};

/**
 * return type of subscription method
 * @param {CheckboxDataType} resultData - information about state checkbox
 * @returns {SubmitType} SubmitType
 */
export const checkUnsubscribe = (resultData: CheckboxDataType): SubmitType => {
    let result: SubmitType;
    if (resultData.isVisible && resultData.isChecked) {
        result = 'SUBSCRIBED';
    }
    return result;
};
// TODO: GUSA-57076
const newsletterSubscription = () => {
    let subscriptionStatus: SubscriptionStatusesType | undefined;
    let subscriptionEmail: string;
    let isSubscriptionEnabledForLocation: boolean;
    const additionalData = {isChangeOnlyEmail: false, nextStep: false};
    const resultData: CheckboxDataType = {isChecked: true, isVisible: false};

    const getTypeSubmit = (): SubmitType => {
        let result: SubmitType;
        switch (subscriptionStatus) {
            case SUBSCRIPTION_STATUSES.UNKNOWN:
                return checkUnknown(resultData);
            case SUBSCRIPTION_STATUSES.SUBSCRIBED:
                return checkSubscribe(resultData);
            case SUBSCRIPTION_STATUSES.TRANSITIONAL:
            case SUBSCRIPTION_STATUSES.UNSUBSCRIBED:
                return checkUnsubscribe(resultData);
            default:
                return result;
        }
    };

    const changeData = () => {
        if (
            subscriptionStatus === SUBSCRIPTION_STATUSES.UNSUBSCRIBED ||
            subscriptionStatus === SUBSCRIPTION_STATUSES.TRANSITIONAL
        ) {
            resultData.isVisible = true;
        } else if (subscriptionStatus === SUBSCRIPTION_STATUSES.SUBSCRIBED) {
            resultData.isVisible = false;
        } else if (subscriptionStatus === SUBSCRIPTION_STATUSES.UNKNOWN) {
            resultData.isVisible = !isSubscriptionEnabledForLocation;
        }
        resultData.isChecked = true;
    };

    return {
        getCheckboxData: (): CheckboxDataType => {
            if (additionalData.nextStep) {
                if (!resultData.isVisible) additionalData.nextStep = false;
                return resultData;
            }
            if (additionalData.isChangeOnlyEmail) {
                additionalData.isChangeOnlyEmail = false;
                return resultData;
            }
            changeData();
            return resultData;
        },
        getData: (): CheckboxDataType => {
            return resultData;
        },
        getEnabledForLocation: (): boolean => {
            return isSubscriptionEnabledForLocation;
        },
        getNextStep: (): boolean => {
            return additionalData.nextStep;
        },
        getSubscriptionEmail: (): string => {
            return subscriptionEmail;
        },
        getSubscriptionStatus: (): SubscriptionStatusesType | undefined => {
            return subscriptionStatus;
        },
        getVisibility: (): boolean => {
            return resultData.isVisible;
        },
        setCheckboxValue: (value: boolean): void => {
            resultData.isChecked = value;
        },
        setEnabledForLocation: (isEnable: boolean): void => {
            isSubscriptionEnabledForLocation = isEnable;
        },
        setNextStep: (isNextStep: boolean): void => {
            additionalData.nextStep = isNextStep;
        },
        setSubscriptionEmail: (email: string): void => {
            if (subscriptionEmail !== email) {
                additionalData.isChangeOnlyEmail = true;
                additionalData.nextStep = false;
            }
            subscriptionEmail = email;
        },
        setSubscriptionStatus: (status: SubscriptionStatusesType | undefined): void => {
            if (subscriptionStatus !== status) additionalData.isChangeOnlyEmail = false;
            subscriptionStatus = status;
        },
        setVisibility: (value: boolean): void => {
            resultData.isVisible = value;
        },
        submitResult: (handleSubscribe: (type: SubmitType) => void | null) => {
            const type = getTypeSubmit();
            additionalData.nextStep = true;
            if (typeof type !== 'undefined') {
                handleSubscribe?.(type);
            }
        },
    };
};

export const managerNewsletterSubscription = newsletterSubscription();
